import React from "react"
import { useIntl } from "gatsby-plugin-react-intl"

const HotelFlightLink = ({ locale }) => {
  const intl = useIntl()

  return locale === "en" ? (
    <a aria-label="Hotel & Flight" className="btn btnLight" href="/en/online-booking-flight-request">
      <span>Hotel & Flight</span>
    </a>
  ) : (
    <a aria-label="Hôtel et vol" className="btn btnLight" href="/demande-de-devis-hotel-vol">
      <span>Hôtel et vol</span>
    </a>
  )
}

export default HotelFlightLink
